import { forwardRef } from 'react'
import { TouchableOpacity } from 'react-native'

import { colors } from '@zet/design-system'
import { Stack, XStack } from '@zet/design-system/layout'
import { B5 } from '@zet/design-system/typography'

import BankIcon from '../../assets/icons/BankIcon'
import CurrencyIcon from '../../assets/icons/CurrencyIcon'
import { M14 } from '../typography'

interface FieldOption {
  optionValue: string
  optionId: any
  icon?: keyof typeof icons
}

interface Props {
  label?: string
  onChange: (value: any) => void
  onBlur: () => void
  isRequired?: boolean
  fieldOptions: FieldOption[]
  value: any
  errorMessage?: string
}

const icons = {
  BankIcon,
  CurrencyIcon,
}

type IconName = keyof typeof icons

const IconRenderer: React.FC<{
  iconName: IconName
  color: string
  size: number
}> = ({ iconName, color, size }) => {
  const IconComponent = icons[iconName]
  if (!IconComponent) {
    return <></>
  }
  return <IconComponent color={color} size={size} />
}

export const Toggle: React.FC<Props> = forwardRef(
  (
    { label, onChange, onBlur, value, errorMessage, isRequired, fieldOptions },
    ref
  ) => {
    return (
      <Stack>
        <XStack>
          {!!label && <M14 className="text-grays-80 my-2">{label}</M14>}
        </XStack>
        <XStack>
          {fieldOptions?.map((item) => (
            <TouchableOpacity
              onPress={() => {
                onChange(item.optionId)
                onBlur()
              }}
              key={item?.optionId}
            >
              <XStack
                style={{
                  borderColor: value !== item?.optionId ? '#F6F7F8' : '#1C1D1F',
                  backgroundColor:
                    value !== item?.optionId ? '#fff' : '#EBECEF',
                }}
                className={`mr-3 items-center justify-between rounded-3xl border px-2 py-2`}
              >
                {item.icon && (
                  <IconRenderer
                    iconName={item.icon}
                    color={colors.grays[70]}
                    size={20}
                  />
                )}
                <M14
                  style={{
                    color: colors.grays[80],
                  }}
                  className={`${
                    value !== item.optionId
                      ? 'font-[Graphie-Regular]'
                      : 'font-[Graphie-SemiBold]'
                  } text-grays-80 ml-2`}
                >
                  {item.optionValue}
                </M14>
              </XStack>
            </TouchableOpacity>
          ))}
        </XStack>
        {!!errorMessage && <B5 className="text-error-100">{errorMessage}</B5>}
      </Stack>
    )
  }
)
